// Mock data for Creek Bottom RV Park & Resort

export const amenities = [
  {
    id: 1,
    icon: "Home",
    title: "Charred Wood Bar & Deck",
    description: "Our signature two-story bar featuring stunning charred wood design - the heart of ranch life with morning coffee, evening cocktails, late-night gatherings, and movie nights",
    image: "https://images.unsplash.com/photo-1596470693312-9a3686a0af0f",
    featured: true
  },
  {
    id: 2,
    icon: "UtensilsCrossed",
    title: "Full Bar & Grill",
    description: "Enjoy delicious food and refreshing drinks at our community gathering spot",
    image: "https://images.unsplash.com/photo-1596470693312-9a3686a0af0f"
  },
  {
    id: 3,
    icon: "Tent",
    title: "Premium Campsites",
    description: "Well-maintained campsites with full hookups and modern amenities",
    image: "https://images.unsplash.com/photo-1596470689751-54f9687c1b7f"
  },
  {
    id: 4,
    icon: "Footprints",
    title: "Hiking Trails",
    description: "Access to scenic hiking trails through the Pineywoods of East Texas",
    image: "https://images.unsplash.com/photo-1604428684385-c5701a00cf1c"
  },
  {
    id: 5,
    icon: "CarFront",
    title: "ATV Trails",
    description: "Explore rugged terrain and farm roads on our designated ATV trail system",
    image: "https://images.unsplash.com/photo-1625495194343-f2d69dae42fb"
  },
  {
    id: 6,
    icon: "Wifi",
    title: "High-Speed WiFi",
    description: "Stay connected with complimentary high-speed internet throughout the property",
    image: "https://images.unsplash.com/photo-1626680114529-3f6ffa002b80"
  },
  {
    id: 7,
    icon: "Maximize2",
    title: "Large RV Pads",
    description: "Spacious pads to accommodate even the biggest rigs, nestled among the pines",
    image: "https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7"
  },
  {
    id: 8,
    icon: "Trees",
    title: "Private Wooded Sites",
    description: "Secluded sites surrounded by piney forests and natural East Texas beauty",
    image: "https://images.unsplash.com/photo-1656740976671-3f4e8bab24c3"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah & Mike Johnson",
    location: "Texas",
    rating: 5,
    text: "The two-story deck is amazing! We spent every evening up there with cocktails watching the sunset over the pastures. The trails are great too!",
    avatar: "SJ"
  },
  {
    id: 2,
    name: "Robert Martinez",
    location: "Colorado",
    rating: 5,
    text: "Love the community vibe here. Morning coffee on the deck, ATV rides through the countryside, and back for evening drinks. Perfect East Texas getaway!",
    avatar: "RM"
  },
  {
    id: 3,
    name: "Linda & Tom Parker",
    location: "Arizona",
    rating: 5,
    text: "The bar & deck is the heart of this place. Made so many friends during movie night! Beautiful Pineywoods setting with all the amenities you need.",
    avatar: "LP"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7",
    alt: "RV camping site"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1604428684385-c5701a00cf1c",
    alt: "Forest hiking trail"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1656740976671-3f4e8bab24c3",
    alt: "Creek with bridge"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1596470693312-9a3686a0af0f",
    alt: "RV on scenic road"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1625495194343-f2d69dae42fb",
    alt: "ATV trail"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1626680114529-3f6ffa002b80",
    alt: "RV on green field"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1656740978495-fbefa5f8f33c",
    alt: "Forest pond"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1635787501769-10b8e23b3ded",
    alt: "Camper at night"
  }
];

export const siteTypes = [
  {
    id: 1,
    name: "RV Sites",
    price: 40.00,
    features: ["30 & 50 Amp Service", "Back-in Sites", "Water & Electric Hookups", "Fire Ring", "WiFi Access", "Bar & Grill Access"],
    description: "Back-in RV sites with both 30 and 50 amp electrical service",
    popular: true,
    availability: 8
  },
  {
    id: 2,
    name: "Primitive Campsite",
    price: 15.00,
    features: ["Fire Ring", "Outdoor Shower Bucket", "Camp Toilet", "Access to Hiking Trails", "Access to ATV Trails", "Peaceful & Secluded"],
    description: "Experience authentic outdoor camping at Creek Bottom Ranch. Perfect for those who want to disconnect and enjoy nature.",
    availability: 4
  }
];

export const mockBookingData = {
  availableDates: [],
  bookedDates: []
};
